import { ResultAnimatedValue } from './result-animated-value'
import { ResultCenteredRow } from './result-centered-row'
import { ResultContainer } from './result-container'
import { ResultCta } from './result-cta'
import { ResultHighlight } from './result-highlight'
import { ResultSimpleRow } from './result-simple-row'
import { ResultValue } from './result-value'
import { ResultValueText } from './result-value-text'

export * from './result-cta'

export const ResultSection = {
  Container: ResultContainer,
  Cta: ResultCta,
  SimpleRow: ResultSimpleRow,
  CenteredRow: ResultCenteredRow,
  Value: ResultValue,
  AnimatedValue: ResultAnimatedValue,
  Highlight: ResultHighlight,
  ValueText: ResultValueText
}
